import { FormFieldBase } from './form-field-base.model';

export class FormFieldFileSelector extends FormFieldBase<string> {
  override controlType = 'file-selector';
}
